"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginAnalytics = void 0;
const marginAnalytics = exports.marginAnalytics = {
  MARGIN_ANALYTICS: {
    en: {
      title: 'Margin Analytics',
      subtitle: 'Keep informed of supply and demand interactions and the direction of margins',
      description: 'In changing commodity markets, your margins are key indicators of where prices are likely to go next. ICIS Margin Analytics is an interactive visualisation built on hundreds of verified data points:',
      list: ['Updated weekly by our team of global experts.', 'Compare margins across competing processes and feedstocks.', 'Keep informed of the latest factors affecting supply.', 'Identify and prepare for price movements.']
    },
    zh: {
      title: '利润分析',
      subtitle: '及时获知供需关系与利润趋势',
      description: '大宗品市场瞬息万变，您的利润对未来价格走势至关重要。ICIS利润分析是一款基于数百个已验证数据点的交互式可视化工具：',
      list: ['全球专家团队每周更新', '对比竞争工艺和原料的利润', '及时获知影响供应的最新因素', '觉察价格波动，并做好准备']
    }
  }
};